<template>
    <div class="addCategoriesComponent">
        <div v-if="loading" class="text-center">
            <v-progress-circular
                class="mt-auto"
                :size="70"
                :width="7"
                color="primary"
                indeterminate
            ></v-progress-circular>
        </div>
        <div  v-else class="row">
            <div class="col-md-7">
                <v-form 
                    ref="form" 
                    lazy-validation 
                    class="mt-5 col-sm-8 col-md-8"
                    >
                    <v-text-field
                        color="secondary" 
                        label="Categoría"
                        placeholder="Ingrese el nombre de la categoría"
                        required
                        v-model="formData.nombreCategoriaComercial"
                        readonly
                        disabled
                    ></v-text-field>
                    <v-text-field
                        color="secondary"
                        label="*Nombre"
                        placeholder="Ingrese el nombre de la subcategoría"
                        v-model="formData.nombre"
                        :counter="25"
                        :maxlength="25"
                        :rules="subcategoryRules"
                        required
                    ></v-text-field>
                    <v-text-field
                        color="secondary"
                        label="*Descripción"
                        placeholder="Ingrese una descripción"
                        v-model="formData.descripcion"
                        :counter="40"
                        :maxlength="40"
                        :rules="descripcionyRules"
                        required
                    ></v-text-field>
                    <v-text-field
                        color="secondary"
                        label="Modo"
                        placeholder="Modo"
                        required
                        v-model="formData.nombreModo"
                        readonly
                        disabled
                    ></v-text-field>
                </v-form>
                <div class="img-btn">

                    <v-tooltip left>

                        <template v-slot:activator="{ on, attrs }">

                            <v-btn
                                fab
                                fixed
                                bottom
                                right
                                dark
                                large
                                color="primary"
                                v-bind="attrs"
                                v-on="on"
                                @click="submitForm"
                                >
                                <v-icon dark>mdi-content-save</v-icon>
                            </v-btn>

                        </template>

                        <span>Guardar Subcategoría</span>

                    </v-tooltip>  
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import Swal from "sweetalert2";
    import  EventBus  from '@/utils/event_bus.js'; 
    import { mapActions, mapGetters } from "vuex";
    import { 
        ACTION_POST_CREATE_SUBCATEGORIES,
        ACTION_GET_CATEGORIES_ID,
        GET_STATE_LOADING,
        GET_CATEGORIES_ID,
        ACTION_GET_MODE,
        GET_MODO,
        BOARD_M,
    } from "@/views/categories_board/store/types/types.js";

    export default {
        name:"addCategoriesComponent",
        props: {
            category: {
                required: true
            },
        },
        data() {
            
            return {
                formData: {
                    nombreCategoriaComercial:this.category.nombre,  
                    idCategoriaComercial: this.category.idCategoriaComercial,
                    nombre: '',
                    descripcion: '',
                    nombreModo: this.category.modo,
                    modo: null,    
                },
                subcategoryRules: [
                    v => !!v || "El nombre de la subcategoría es requerido",
                    v => (v && v.length <= 25) || "El nombre no puede tener más de 25 caracteres"
                ],
                descripcionyRules: [
                    v => !!v || "La descripcion de la subcategoría es requerido",
                    v => (v && v.length <= 40) || "La descripción no puede tener más de 40 caracteres"
                ],
                showErrorMessages: false
            };
        },

        async mounted() {
            // id del modo
            await this.getMode();
            const modos = await this.modes
            this.formData.modo = modos[1].idModoCategoria;

            EventBus.$on('reload-update-categories-sub', async ()  => {
                await this.getcategory(this.category.idCategoriaComercial);
                await this.updatecategory();
            });
            await this.getcategory(this.category.idCategoriaComercial);
        },

        methods: {

            ...mapActions({
                getMode: `${BOARD_M}${ACTION_GET_MODE}`,
                putUpdateSubCategoria: `${BOARD_M}${ACTION_POST_CREATE_SUBCATEGORIES}`,
                getcategory: `${BOARD_M}${ACTION_GET_CATEGORIES_ID}`,

            }),

            updatecategory(){
                this.formData.nombreCategoriaComercial = this.categoryConsult.nombre
            },

            async submitForm() {
                // Validar el formulario antes de enviarlo
                const validationErrors = this.validateForm();

                // Si hay errores de validación, mostrarlos en un único Swal y no enviar el formulario
                if (Object.keys(validationErrors).length > 0) {
                    const errorMessages = Object.values(validationErrors).join('<br>');
                    Swal.fire({
                        icon: 'error',
                        title: 'Errores de validación',
                        html: '<div class="swal-subtitle"><b>Los siguientes campos son requeridos:</b></div><br>' + errorMessages,
                        confirmButtonColor: '#6E17A5'
                    });
                    return;
                }

                // Si no hay errores de validación, imprime el formulario en la consola
                const save = this.putUpdateSubCategoria(this.formData);
                if(!save){
                    return Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Debes diligenciar los campos'
                    })

                }

                await this.clearForm();
                EventBus.$emit('formSub-submitted-successfully');
                
            },

            clearForm() {
                this.formData.nombre = '';
                this.formData.descripcion = '';
                
            },

            validateForm() {
                this.showErrorMessages = true;

                const errors = {};

                if (!this.formData.idCategoriaComercial) {
                    errors.categoriaBeneficio = 'Categoría';
                }

                if (!this.formData.nombre || !this.formData.nombre.trim()) {
                    errors.nombre = 'Nombre';
                }

                if (!this.formData.descripcion || !this.formData.descripcion.trim()) {
                    errors.descripcion = 'Descripción';
                }

                if (!this.formData.modo) {
                    errors.descripcion = 'Modo';
                }
                
                return errors;
            },

          
        },

        computed: {

            ...mapGetters({
                modes: `${BOARD_M}${GET_MODO}`,
                loading: `${BOARD_M}${GET_STATE_LOADING}`,
                categoryConsult: `${BOARD_M}${GET_CATEGORIES_ID}`,
            }),

        },

    };

</script>


<style lang="css" scoped>

        input[type="file"] {
            left: 0;
            top: 0;
            opacity: 0;
            width: 100%;
            height: 100%;
        }

    /* Css input imagen*/

    .col-md-7 {
        display: flex;
        justify-content: center;
        align-items: center;
        gap:230px;
    }
    .row {
        display: flex;
        justify-content: center;
    }


    /*Resposive*/
    @media screen and (min-width: 912px) {
    .col-md-7 {
        gap: 90px
    }
    }

    @media screen and (max-width: 768px) {
        .col-md-7 {
            gap: 25px;
        }
    }
    @media screen and (max-width: 425px) {
        .col-md-7 {
            
            display: flex;
            flex-direction: column-reverse;
            gap: 25px;
        } 
    }

</style>